import { Tag } from 'antd'
import { useTranslation } from "react-i18next";

const OrderStatusColorCodes = {
    "PENDING": "orange",
    "PREPARING": "volcano",
    "ON_THE_WAY": "geekblue",
    "COMPLETE": "green",
    "CANCELED": "red",
    "CANCELLED": "red",
    "REJECTED": "magenta",
    "SCHEDULED": "gold"
  }

const OrderStatusTag = ({status, className=""}) => {
  const { t } = useTranslation();
  return (
    <Tag color={OrderStatusColorCodes?.[status] ?? "default"} className={`font-semibold content-center ${className}`} style={{
      marginRight:0
    }}>{t(status?.replaceAll("_"," "))}</Tag>
  )
}

const PAYMENT_GATEWAYS = {
  "STRIPE": "orange",
  "PAYBY": "green",
  "AFS_PAYMENT": "geekblue"
}
export const PaymentGatewayTag = ({gateway, className=""}) => {
  const { t } = useTranslation();
  return (
    <Tag color={PAYMENT_GATEWAYS?.[gateway] ?? "default"} className={`font-semibold content-center ${className}`} style={{
      marginRight:0
    }}>{t(gateway?.replaceAll("_"," "))}</Tag>
  )
}

export default OrderStatusTag